<template>
  <v-container class="justify-center">
    <v-row>
      <v-col cols="12">
        <h3>หัวข้อเรื่อง</h3>
      </v-col>
      <v-col cols="12">
        <v-card class="my-1">
          <v-card-text>
            <v-list-item>
              <v-list-item-content>
                <v-textarea
                  readonly
                  :value="form.subjectDesc"
                  solo
                ></v-textarea>
                <div>
                  <b>เจ้าของเรื่อง : </b>
                  {{
                    profileLookup[form.createBy] &&
                    profileLookup[form.createBy].FULLNAME
                  }}
                </div>
                <div>
                  <b>ผู้อนุมัติ : </b>
                  <template v-for="(approver, key) in approvers">
                    <div :key="key">
                      <span>
                        {{
                          profileLookup[approver] &&
                          profileLookup[approver].FULLNAME
                        }}
                      </span>
                      <span v-if="key + 1 < approvers.length">, </span>
                    </div>
                  </template>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>แผนดำเนินการ</h3>
      </v-col>
      <v-col cols="12">
        <!-- {{listPlans}} -->
        <div v-for="(obj, key) in listPlans" :key="key">
          <ActionProgress
            :obj="listPlans[key]"
            :profileLookup="profileLookup"
            class="pt-2"
          ></ActionProgress>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :class="`d-flex justify-center`">
        <v-btn
          cols="4"
          class="ma-2 pa-2"
          color="primary"
          outlined
          dark
          @click="previous"
          >ย้อนกลับ</v-btn
        >
        <!-- </v-col>
        <v-col cols="3">-->
        <!-- <v-btn cols="4" class="ma-2 pa-2" color="primary" dark @click="doUpdate">บันทึก</v-btn> -->
        <!-- </v-col>
        <v-col cols="4">-->
        <!-- <v-btn cols="4" class=" ma-2 pa-2" color="green" dark @click="validate('complete')">บันทึก และ ส่ง</v-btn> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ActionProgress from "./action-progress";
export default {
  components: {
    ActionProgress,
  },
  data() {
    return {
      listPlans: [],
      actionPlanInit: [],
      form: {},
      approvers: [],
      listsProfileEmp: [],
      offset: 0,
      loading: false,
      token: {},
    };
  },
  created() {
    this.getProfile();
    this.getInit();
    this.token = JSON.parse(localStorage.getItem("MakeItSimpleV2"));
  },
  computed: {
    profileLookup() {
      let data = [];
      this.listsProfileEmp.reduce((prev, pres) => {
        data[pres.USERNAME] = pres;
      }, {});
      //console.log(data);
      return data;
    },
  },
  methods: {
    async getInit() {
      this.SwalLoading("กำลังโหลดข้อมูล", "รอสักครู่...");
      let { res } = await this.GetHttp(
        `MISPV2/GetProjectById/${this.$route.query.subjectId}`
      );
      if (res.data.status) {
        this.form = res.data.subject[0] || {};
        this.approvers = res.data.approvers || [];
        this.listPlans = res.data.action_plan.map((e, idx) => {
          return { sort: res.data.action_plan.length - idx, ...e };
        });
        this.actionPlanInit = JSON.parse(JSON.stringify(res.data.action_plan));
      }
      //console.log(this.approvers);
      this.SwalClose();
    },
    async getProfile() {
      let { res } = await this.GetHttp("MISPV2/GetProfileEmp");
      if (res.data.status) {
        this.listsProfileEmp = res.data.lists_profile_emp || [];
      } else {
      }
    },
    async doUpdate(status = "") {
      // this.actionPlanInit

      let dataActionPlan = this.compareRows(
        ["planId"],
        this.listPlans /* ค่าใหม่ */,
        this.actionPlanInit /* ค่าเดิม */,
        [
          "planProgress",
          "planProgressDetail",
          "updateBy",
        ] /* ฟิลด์ที่ต้องการเปลียบเทียบ */
      );
      let obj = {
        // subjectDesc: this.form.subjectDesc,
        updateBy: this.token.loginCode,
        plans: dataActionPlan,
      };

      // if (status === 'complete') { /* บันทึกและส่ง*/
      //   obj.subjectStatus = status
      // }

      //console.log("obj", obj);

      let { res } = await this.PutHttp(
        `MISPV2/UpdateProgress/${this.$route.query.subjectId}`,
        obj
      );
      if (res.data.status) {
        //console.log("บันทึกสำเร็จ");
        this.$router.push("/app-lists-inform");
      } else {
        //console.log("บันทึกไม่สำเร็จ");
      }
    },
    previous() {
      switch (this.$route.query.pageType) {
        case "review":
          this.$router.push("/app-lists-inform-review");
          break;
        default:
          this.$router.push("/app-lists-inform");
          break;
      }
    },
  },
};
</script>

<style>
</style>